<template>
  <div
    data-testid="drawer-modal"
    v-if="isOpen"
    class="fixed inset-0 w-full z-50 h-full bg-gray-transparent overflow-y-auto"
    @click.self="close"
    v-show="show"
  >
    <div
      :class="drawerWidthClass"
      class="fixed top-0 right-0 h-full bg-white md:pb-6"
    >
      <div
        class="w-full bg-teal-accent flex items-center px-5 py-3 justify-between"
      >
        <div class="flex">
          <FilterIcon stroke-width="0.5" />
          <p
            data-testid="drawer-modal-title"
            class="inline-block font-montserrat text-sm font-bold uppercase leading-5 pl-4 self-center"
          >
            {{ title }}
          </p>
        </div>
        <div
          data-testid="drawer-modal-close"
          class="flex w-6 h-6 justify-center items-center shrink-0 cursor-pointer"
          @click="close"
        >
          <CloseIcon stroke="#007f80" />
        </div>
      </div>
      <div class="overflow-auto h-[90%] w-full">
        <slot name="modal-content" />
      </div>
      <div
        class="fixed flex justify-center bg-white items-center bottom-0 py-8 footer"
        :class="drawerWidthClass"
      >
        <slot name="modal-footer" />
      </div>
    </div>
  </div>
</template>

<script setup>
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import FilterIcon from "@/components/svg-icons/FilterIcon.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  show: {
    type: Boolean,
    required: false,
    default: true,
  },
  title: {
    type: String,
    required: true,
  },
  drawerWidthClass: {
    type: String,
    default: "w-[80%] md:w-[37rem]"
  }
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>
<style scoped>
.footer {
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
}
</style>
